import { createSlice } from "@reduxjs/toolkit";
import { adminChangeRoleAction, adminDeleteAction, adminDetailAction, adminEditAction, adminEditProfileSettingsAction, adminListAction, resetadminAction } from "../Action/manageAdminAction";

const initialState = {
    admins: [],
    adminDetail:{},
    createadminStatus:'idle',
    adminDetailstatus:'idle',
    adminDeleteStatus:"idle",
    adminSuspendStatus:"idle",
    adminEditStatus:"idle",
    adminChangeRoleStatus:"idle",
    adminesetPassStatus:"idle",
    adminEditProfileSettingsStatus:"idle",
    multiadmincreateStatus:"idle",
    adminDailyUsageDetail :{}
}

const manageAdminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(adminListAction.fulfilled, (state, action) => {
                state.admins = action?.payload?.data;
            })


            .addCase(adminDetailAction.fulfilled, (state, action) => {
                state.adminDetail = action?.payload?.data;
            })

            .addCase(adminDeleteAction.fulfilled, (state, action) => {
                state.adminDeleteStatus = 'succeeded';
            })

            .addCase(adminChangeRoleAction.fulfilled, (state, action) => {
                state.adminChangeRoleStatus = 'succeeded';
            })



                .addCase(adminEditProfileSettingsAction.fulfilled, (state, action) => {
                            state.adminEditProfileSettingsStatus = 'succeeded';
                        })
            

               .addCase(adminEditAction.fulfilled, (state, action) => {
                            state.adminEditStatus = 'succeeded';
                        })
                       

            
            .addCase(resetadminAction, () => initialState);
            
            
            

    },
});

export default manageAdminSlice.reducer;



